import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
  type WidgetActionSchema,
} from '@/entities/widget';
import {
  AudienceFlowWidgetSchemaKey,
  type AudienceFlowWidget,
} from '@inference.engine/widgets/web';

/**
 * Factory that binds the AudienceFlow widget processor to the supplied dep
 * surface. Returns the processor list consumed by the central widget
 * dispatcher in `features/widgets/processors/`.
 *
 * The widget slice MUST NOT value-import `widgetProcessorDeps` from
 * `@/features/widgets/processors/...`. The dispatcher binds with deps once.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const create: WidgetActionProcessor<WidgetActionSchema<AudienceFlowWidget>> = {
    key: AudienceFlowWidgetSchemaKey,
    processor: makeCreateWidgetAction(deps) as WidgetActionProcessor<
      WidgetActionSchema<AudienceFlowWidget>
    >['processor'],
  };
  return [create];
};
